<template>
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <section v-if="!$route.meta.invisible && !$route.meta.invisibles">
      <div class="breads container">
        <bread></bread>
      </div>
      <div class="container">
        <SeqTopSearch
          :orderNos.sync="orderNos"
          :tabList="tabList"
          :useInfo="useInfo"
          lastBtnText="开始拼接"
          @upload="handleUploadFile"
          @start="handleStart"
          @clear="clearTableData"
        />
        <template v-if="tableData.length">
          <div class="flex flex-justify-end flex-align-center mb10 mt10">
            <el-button
              v-for="(item, index) in buttonList"
              :key="index"
              type="primary"
              @click="handleDownload(item.value)"
              class="download-btn"
            >
              <i class="el-icon-download"></i>
              {{ item.label }} 
            </el-button>
          </div>
          <el-table
            class="tools-table"
            max-height="450"
            border
            :data="tableData"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" align="center" width="50" />
            <el-table-column prop="orderCode" label="订单编号" />
            <el-table-column prop="demoName" label="样品名" />
            <el-table-column
              prop="joinStatus"
              label="拼接状态"
              :filters="statusList"
              :filter-method="filterStatus"
            >
              <template slot-scope="scope">
                <span :style="{'color': baseMethods.enToChinese(scope.row.joinStatus, statusList ,'color')}">
                  {{ baseMethods.enToChinese(scope.row.joinStatus, statusList ,"text") }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="joinLength" label="拼接长度" />
            <el-table-column prop="remark" label="备注" />
            <el-table-column prop="button" label="操作">
              <template slot-scope="scope">
                <el-button
                  class="table-btn"
                  type="text"
                  v-if="scope.row.joinStatus === 'SUCCESS'"
                  @click="handleDownload(buttonList[0].value, scope.row)"
                  >下载</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="page tr">
            <el-pagination
              layout="total, sizes, prev, pager, next"
              :total="total"
              @size-change="changeSizes"
              @current-change="changePage"
            >
            </el-pagination>
          </div>
        </template>
      </div>
    </section>
  </div>
</template>
<script>
import bread from "@/components/bread";
import SeqTopSearch from "./component/SeqTopSearch";
import { showLoading, hideLoading } from "@/views/user/children/loading";
import { seqJoinByCode, seqJoinByPage, seqJoinDownload, seqJoinByFile } from "@/services/api.tools";
export default {
  components: { bread, SeqTopSearch },
  data() {
    return {
      orderNos: "",
      tableData: [],
      tabList: [
        {
          label: "订单号维度",
          name: "order",
        },
        {
          label: "ab1峰图维度",
          name: "ab1",
        },
      ],
      useInfo:{
        list: [
          "使用说明：",
          "1、数据格式：需处理的数据为.ab1峰图或峰图压缩包（只支持.zip）或多个ab1。",
          "2、ab1命名：即“样品_引物_订单号_孔号.ab1”。注：“_”为一条下划线。",
          "3、软件拼接准确率为99%以上，拼接结果比对过程中，若发现个别碱基有问题，请以原始峰图为准。",
          "4、使用详情，请点击：文档指南或视频指南。",
          "5、如有异常，请发送具体问题到对应邮箱：Cloud_Tool_Problem@tsingke.com.cn",
        ]
      },
      statusList: [
        {
          value: "SUCCESS",
          color: "#00AE1E",
          text: "成功",
        },
        {
          value: "FAIL_ONLY_ONE",
          color: "#E99F00",
          text: "只有一个结果，无法拼接",
        },
        {
          value: "FAIL",
          color: "#F62B2B",
          text: "失败",
        },
      ],
      buttonList: [
        {
          label: "seq格式",
          value: "SEQ",
        },
        {
          label: "txt格式",
          value: "TXT",
        },
        {
          label: "fasta格式（分）",
          value: "FASTA_SPLIT",
        },
        {
          label: "fasta格式（总）",
          value: "FASTA_MERGE",
        },
      ],
      total: 0,
      page: 0,
      pageSize: 10,
      selectionList: [],
      prefixName: "拼接文件",
      reqId: "" //下载唯一标识
    };
  },
  mounted() {
    this.orderNos = this.$route.params.nos
      ? this.$route.params.nos.join(";")
      : "";
    console.log(this.orderNos);
  },
  methods: {
    async handleUploadFile(file,callback) {
      showLoading({ text: "正在分析中，请耐心等待！" });
      try {
        let res = await seqJoinByFile(file)
        if(res){
          const { list, reqId, totalCount } = res.data
          this.tableData = list;
          this.reqId = reqId;
          this.total = totalCount;
          this.$message.success("分析完成");
          callback(true)
        }
      } finally {
        hideLoading();
      }
    },
    async handleStart() {
      this.tableData = [];
      showLoading({ text: "正在分析中，请耐心等待！" });
      try {
        let res = await seqJoinByCode({orderCode: this.orderNos})
        if(res.status === 200){
          const { list, reqId, totalCount } = res.data
          this.tableData = list;
          this.reqId = reqId;
          this.total = totalCount;
          this.$message.success("分析完成");
        }
      } finally {
        hideLoading();
      } 
    },
    clearTableData() {
      this.tableData = [];
      this.reqId = "";
      this.page = 0;
    },
    filterStatus(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    handleSelectionChange(val) {
      this.selectionList = val;
    },
    // 翻页
    changePage(value) {
      this.page = value - 1;
      this.getOrders();
    },
    changeSizes(value) {
      this.pageSize = value;
      this.refresh();
    },
    refresh() {
      this.page = 0;
      this.getOrders();
    },
    async getOrders() {
      const { page, pageSize, reqId } = this;
      let res = await seqJoinByPage({reqId, page, size: pageSize})
      if(res.status === 200){
        const { list, reqId, totalCount } = res.data
        this.tableData = list;
        this.reqId = reqId;
        this.total = totalCount;
      }
    },
    // 下载按钮
    async handleDownload(type, row) {
      if (!row && !this.selectionList.length)
        return this.$message.warning("请选择数据");
      const idList = row ? row.id : this.selectionList.map((item)=> item.id).toString()
      console.log(idList)
      showLoading({ text: "文件下载中，请耐心等待！" });
      try {
        let res = await seqJoinDownload(this.reqId, { type, idList})
        if(res.data){
          this.baseMethods.downloadFile(
            res.data,
            `${this.prefixName}${this.baseMethods.dateToString()}`,
            "zip"
          );
        }
      } catch(err) {
        const fileReader = new FileReader()
        fileReader.readAsText(err,'utf-8')
        fileReader.onload = ()=>{
          const result = JSON.parse(fileReader.result)
          console.log("catch", result)
          this.$message.error(result.title);
        }
      } finally {
        hideLoading();
      }
      
    },
  },
};
</script>
<style scoped lang="scss">
.breads {
  overflow: auto;
  line-height: 48px;
}
.table-btn {
  padding: 0px;
}

</style>


// WEBPACK FOOTER //
// src/views/tools/seqStitching.vue